// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"119":"store","439":"contatti","443":"about","728":"soluzioni","918":"progetto"}[chunkId] + "." + {"119":"813a149d","439":"f5a04aab","443":"fc4b5a5e","728":"ed65a2c6","918":"1bcaf3bb"}[chunkId] + ".js";
};